import { View, Pressable, StyleSheet } from 'react-native';
import { brand } from 'src/theme/colors';
import { Icon } from '../icon/Icon';
import { ICON_NAMES } from '../icon/icon.helper';
import { useStore } from 'src/contexts/StoreContext';
import { BOTTOM_SHEET_VIEWS } from 'src/store/bottom-sheet/bottomSheet.constants';
import { observer } from 'mobx-react-lite';

export const PrivacyPolicyCtaMobile = observer(() => {
  const {
    i18n,
    bottomSheet: { openBottomSheet },
  } = useStore();
  const onPressIcon = () => {
    openBottomSheet({
      showOpacityBackground: true,
      showDragIndicator: false,
      bottomSheetView: BOTTOM_SHEET_VIEWS.PrivacyPolicy,
    });
  };
  return (
    <View style={style.iconInfo}>
      <Pressable
        onPress={onPressIcon}
        accessible={true}
        accessibilityLabel={i18n.t('modal-privacy-policy:privacy-policy-info')}
        accessibilityRole="button"
      >
        <Icon name={ICON_NAMES.Info} color={brand.main.water} />
      </Pressable>
    </View>
  );
});

const style = StyleSheet.create({
  iconInfo: {
    width: 24,
    height: 24,
    padding: 1,
  },
});
